import { render, staticRenderFns } from "./AlipayNotice.vue?vue&type=template&id=21d45e70&scoped=true&"
import script from "./AlipayNotice.vue?vue&type=script&lang=js&"
export * from "./AlipayNotice.vue?vue&type=script&lang=js&"
import style0 from "./AlipayNotice.vue?vue&type=style&index=0&id=21d45e70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d45e70",
  null
  
)

export default component.exports